import { gql } from "@apollo/client";

export const GET_WATER_SYSTEM_MENU = gql`
  query WaterSystemMenu {
    getWaterSystemMenu {
      value
      label
    }
  }
`;

export const GET_WATER_SYSTEM_RESULTS = gql`
  query WaterSystemSearch($searchString: String!) {
    waterSystemSearch(searchString: $searchString) {
      systemId
      pwsId
      systemName
      systemType
      alternateNum
      activityStatus
      county
    }
  }
`;

export const GET_WATER_SYSTEM_SUMMARY = gql`
  query WaterSystemSummary($pwsId: String!) {
    getWaterSystemSummary(pwsId: $pwsId) {
      systemId
      pwsId
      systemName
      activityStatus
      population
      systemType
      lastInventoryUpdateDate
      countyServed
      county
      alternateNum
      adminContact {
        email
        email2
        email3
        adminFirstName
        adminLastName
        adminPhone
        adminPhoneExt
        adminEmergencyPhone
        adminEmergencyPhoneExt
      }
      legalContact {
        certLevel
        certType
        lcFirstName
        lcAddress1
        lcAddress2
        lcCity
        lcState
        lcZip
        lhdName
        phone
      }
      rating {
        rating
        ratingDate
        ipsLastUpdateTs
        totalIpsPoints
      }
      operatingPeriod {
        operatorEndDay
        operatorEndMonth
        operatorStartDay
        operatorStartMonth
        lastUpdateDate
      }
      lastSurvey {
        surveyorFirstName
        surveyorLastName
        surveyDate
      }
      zone {
        zone
        zoneDate
      }
      district {
        indicatorName
        districtNumber
      }
      waterUsage {
        createdTs
        peakDayDemand
        avgAnnualDemand
        equalizationStorage
      }
    }
  }
`;

export const GET_WATER_SYSTEM_SEARCH_LIST = gql`
  query WaterSystemSearchList {
    getWaterSystemSearchList {
      systemId
      pwsId
      systemName
      systemType
      alternateNum
      activityStatus
      county
    }
  }
`;

export const GET_SYSTEM_HEADER_VIEW = gql`
  query SystemHeaderView($systemId: String!) {
    getSystemHeaderViewBySystemId(systemId: $systemId) {
      systemId
      pwsId
      systemName
      status
      population
      systemType
      lastInventoryUpdateDate
      countyServed
      rating
      ratingDate
      surveyorName
      surveyDate
      operatorStartDay
      operatorStartMonth
      operatorEndDay
      operatorEndMonth
      lastUpdateDate
      zone
      zoneDate
      alternateNumber
      ipsLastUpdateTs
      siteContact {
        systemId
        firstName
        city
        state
        phone
        email
      }
      politicalDistricts {
        indicatorName
        districtNumber
      }
      adminContact {
        firstName
        lastName
        phone
        phoneExt
        phone2
        phone2Ext
        email
        contactType
      }
    }
    getSystemLatLongCoords (systemId: $systemId){
      latitude
      longitude
    }
    getSystemFolderUrl (systemId: $systemId){
      value
    }
  }
`;

export const GET_WATER_SYSTEM_LF_URL_LINK = gql`
  query GetLFLinkbySystemId($pwsId: String!) {
    getLFLinkbySystemId(pwsId: $pwsId) {
      tinwsysIsNumber
      urlLink
    }
  }
`;

export const GET_WATER_SYSTEM_LAT_LONG = gql`
  query GetSystemLatLongCoords($pwsId: String!) {
    getSystemLatLongCoords(pwsId: $pwsId) {
      latitude
      longitude
    }
  }
`;
